import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Button, Typography, Dialog, } from '@mui/material';
import moment from 'moment';

import UploadFiles from './UploadFiles';
import { Delete, AttachFile, AddCircleOutline } from '@mui/icons-material';
import { getData } from '../../services/library';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// import Dialog from '@mui/material';
import Container from "@mui/material/Container";

function ModalVerReq(props) {
  const [listaMateriales, setlistaMateriales] = useState(null);
  const [datosReq, setDatosReq] = useState(null)
  const [datos, setDatos] = useState(props.datos);
  const [openclose, setOpenClose] = useState(false);
  const [circular, setCircular] = useState(false);

  const obtenerListaMateriales = async () => {
    getData('/lista_materiales/nro_req/' + datos.uuid_requerimiento, setlistaMateriales)
    setCircular(true);
    setTimeout(() => {
      setCircular(false);
    }, 500);
  };

  useEffect(() => {
    obtenerListaMateriales();
  }, []);

  useEffect(() => {
    getData('/requerimientos_materiales/ordencompra/' + datos.uuid_ordencompra, setDatosReq)
  }, [datos.uuid_ordencompra]);

  const style = {
    backgroundColor: "#ffffff",
    width: "100%"
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#92a898",
      color: theme.palette.common.white,
      fontSize: 14,
      padding: 5
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: 5,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: "white",
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));


  return (
    <>
      <Dialog open={props.open} onClose={() => props.open(false)} maxWidth="lg"  mb ={2}>
        <Container >
          <Box
            key={datos.idrequerimiento}
            width="100%"
            role="presentation" onClick={() => props.open(false)}
            backgroundColor="#CCD1D1"
            alignItems="center"
            justifyContent="center"
            mt={1} mb={2}>
            <Typography
              variant="overline"
              display="block"
              gutterBottom
              textAlign="center"
            >
              Visualización de requerimiento {datos.idrequerimiento}
            </Typography>
          </Box>

          <Box
            backgroundColor="#F4F6F6"
            p={2}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}>

            <Grid container spacing={1} alignItems="center" justifyContent="space-between">
              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.nombre_sucursal}
                  style={style}
                  label="Sucursal"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.patente !== null ? datos.patente : "No hay registro"}
                  style={style}
                  label="Patente"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.fecha_entrega ? moment(datos.fecha_entrega).format("DD-MM-YYYY") : "Sin Registrar"}
                  style={style}
                  label="Fecha de entrega"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  focused
                  color="primary"
                  size="small"
                  value={datos.nombrepila + " " + datos.apellido}
                  style={style}
                  label="Autoriza"
                  InputProps={{
                    readOnly: true,
                  }} />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ width: '100%' }}>
            <TableContainer component={Paper}>
              <Table sx={{ mt: 1 }} aria-label="Tabla de materiales y costos">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">Cantidad</StyledTableCell>
                    <StyledTableCell align="left">Unidad</StyledTableCell>
                    <StyledTableCell align="left">Articulo/Servicio</StyledTableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {listaMateriales?.length ? (
                    listaMateriales.map((lista) => (
                      <StyledTableRow key={lista.idlista}>
                        <StyledTableCell align="left">{lista.cantidad}</StyledTableCell>
                        <StyledTableCell align="left">{lista.descripcion ?? lista.descripcion_material}</StyledTableCell>
                        <StyledTableCell align="left">{lista.nombre ?? lista.material}</StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No hay materiales disponibles
                      </TableCell>
                    </TableRow>
                  )}

                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box>
            <TextField
              focused
              margin="dense"
              variant="filled"
              size="small"
              value={datos.comentarios_internos ? datos.comentarios_internos : "No hay comentarios cargados."}
              style={style}
              multiline

              label="Comentarios internos"
              InputProps={{
                readOnly: true,
              }} />
          </Box>

          <Grid item xs={2}  mb ={2}>
            <Button onClick={() => setOpenClose(!openclose)} variant="outlined" style={{
              borderColor: "#13406e",
              backgroundColor: "#ffffff",
            }}
              startIcon={<AttachFile />} >Visualizar presupuestos</Button>
          </Grid>



        </Container>
      </Dialog>

      <br />
      <br />
    </>
  )

}

export default ModalVerReq
